/* eslint-disable @next/next/no-img-element */
"use client";
import { useState, useEffect } from "react";
import Link from "next/link";
import { compareExperiencesByPriority } from "@/utils/experienceSort";

type Attraction = {
  id: string;
  title: string;
  description: string;
  image: string;
  background: string;
  complement: string;
  hasQueue: boolean;
  hasComplement: boolean;
  isActive: boolean;
  localId: string;
};

const SELECTED_ATTRACTION_STORAGE_KEY = "selected-attraction";

export default function Experiences() {
  const [exp, setExp] = useState<Attraction[]>([]);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/immutability
    getExp();
  }, []);
  async function getExp() {
    const req = await fetch(
      `api/list-atracoes?state=${localStorage.getItem("state") === "SP" ? 1 : 2}`,
      { cache: "no-store" },
    )?.then(async (res) => await res.json());
    const sortedAttractions = Array.isArray(req)
      ? [...req].sort(compareExperiencesByPriority)
      : [];

    setExp(sortedAttractions);
  }

  function handleSelectAttraction(attraction: Attraction) {
    window.sessionStorage.setItem(
      SELECTED_ATTRACTION_STORAGE_KEY,
      JSON.stringify(attraction),
    );
  }

  function renderColor(color: string) {
    switch (color) {
      case "#fec822":
        return "#2033ef";
        break;

      case "#FEC822":
        return "#2033ef";
        break;

      case "#fec823":
        return "#2033ef";
        break;

      case "#FEC823":
        return "#2033ef";
        break;

      case "#FFE800":
        return "#2033ef";
        break;

      case "#FFE600":
        return "#2033ef";
        break;

      default:
        return "#fff";
        break;
    }
  }

  return (
    <section
      className="faq-section reveal-up"
      id="experiences"
      style={{
        backgroundColor: "#2033ef",
        height: 254,
      }}
    >
      <div className="pl-5">
        <div className="flex flex-col">
          <h1 className="font-extrabold text-white text-[26px] -mt-5 mb-3">
            EXPERIÊNCIAS
          </h1>

          <div className="scrollbar-hidden mt-2 flex w-full gap-5 overflow-x-auto overflow-y-hidden pr-5 pb-2 mb-6">
            {exp?.map((attraction) => (
              <Link
                key={attraction.id}
                href={`/experiencias/${attraction.id}`}
                onClick={() => handleSelectAttraction(attraction)}
                className="overflow-hidden rounded-[20px] min-w-[294px] justify-center flex flex-col items-center"
                style={{ backgroundColor: attraction.background }}
              >
                <img
                  className="flex h-[90px] w-[180px] min-w-[180px] object-contain p-5"
                  src={attraction.image}
                  alt={attraction.title}
                />
                <h1
                  className="text-[11px] mt-1 pb-2 text-center font-bold uppercase"
                  style={{
                    color: renderColor(attraction.background),
                  }}
                >
                  {attraction.title}
                </h1>
              </Link>
            ))}
          </div>
        </div>
      </div>

      <style jsx>{`
        .faq-section {
          background: #fff;
          padding: 4rem 0 5rem;
          scroll-margin-top: 6.5rem;
        }

        .faq-shell {
          display: grid;
          gap: 2rem;
        }

        .faq-heading {
          display: grid;
          gap: 1.25rem;
        }

        .faq-badge {
          display: inline-flex;
          width: fit-content;
          align-items: center;
          gap: 0.75rem;
          border: 1px solid #fec822;
          color: #fec822;
          padding: 0.9rem 1.1rem;
          font-size: 0.72rem;
          font-weight: 900;
          text-transform: uppercase;
          letter-spacing: 0.06em;
        }

        .faq-badge-dot {
          width: 0.5rem;
          height: 0.5rem;
          border-radius: 999px;
          background: #fec822;
        }

        .faq-title-row {
          display: flex;
          align-items: center;
          gap: 1rem;
        }

        .faq-region-title {
          color: #fec822;
          font-size: clamp(2rem, 4vw, 3.25rem);
          font-weight: 950;
          line-height: 0.96;
          text-transform: uppercase;
        }

        .faq-region-subtitle {
          margin-top: 0.5rem;
          color: rgba(255, 255, 255, 0.86);
          font-size: 0.95rem;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.08em;
        }

        .faq-filters {
          display: flex;
          flex-wrap: wrap;
          gap: 0.75rem;
        }

        .faq-filter {
          min-width: 92px;
          border: 1px solid #2033ef;
          border-radius: 999px;
          background: transparent;
          color: #2033ef;
          padding: 0.85rem 1.2rem;
          font-size: 0.95rem;
          font-weight: 900;
          cursor: pointer;
        }

        .faq-filter.is-active {
          background: #fec822;
          border-color: #fec822;
          color: #2033ef;
        }

        .faq-sections {
          display: grid;
          gap: 1.5rem;
        }

        .faq-section-block {
          display: grid;
          gap: 0.85rem;
        }

        .faq-section-label {
          color: #2033ef;
          font-size: 0.95rem;
          font-weight: 900;
          text-transform: uppercase;
          letter-spacing: 0.1em;
        }

        .faq-list {
          display: grid;
          gap: 0.9rem;
        }

        .faq-item {
          border: 1px solid rgba(255, 255, 255, 0.18);
          border-radius: 24px;
          background: rgba(255, 255, 255, 0.08);
          overflow: hidden;
          backdrop-filter: blur(10px);
        }

        .faq-item.is-open {
          background: white;
          border-color: white;
          color: #fff;
        }

        .faq-question {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 1rem;
          border: 0;
          background: #2033ef;
          color: inherit;
          padding: 1.25rem 1.35rem;
          text-align: left;
          font-size: 1rem;
          font-weight: 800;
          cursor: pointer;
        }

        .faq-icon {
          flex-shrink: 0;
          width: 2rem;
          height: 2rem;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border-radius: 999px;
          background: #fec822;
          color: #2033ef;
          font-size: 1.4rem;
          line-height: 1;
        }

        .faq-answer {
          padding: 0 1.35rem 1.35rem;
          display: grid;
          gap: 0.85rem;
          color: #fff;
          font-size: 0.96rem;
          line-height: 1.6;
          background: #2033ef;
        }

        @media (max-width: 768px) {
          .faq-section {
            padding: 3rem 0 4rem;
          }

          .faq-title-row {
            align-items: flex-start;
          }

          .faq-question {
            padding: 1.05rem 1.1rem;
            font-size: 0.95rem;
          }

          .faq-answer {
            padding: 0 1.1rem 1.1rem;
            font-size: 0.92rem;
          }
        }
      `}</style>
    </section>
  );
}
